/*
 * Copyright (c) Orion Developments Ltd and the Orion Health group of companies (2001 - 2021).
 *
 * This document is subject to copyright. Except as permitted by copyright law
 * applicable to you, no part of this publication may be reproduced or
 * transmitted in any form or by any means, electronic or mechanical, including
 * photocopying, recording, downloading, or any information storage and
 * retrieval system, without permission in writing from Orion Developments
 * Limited. Infringers of copyright render themselves liable for prosecution.
 */

import Alert from '@material-ui/lab/Alert';

export default function DisplayError() {
    const message = new URLSearchParams(document.location.search).get('message') || "There was an error"
    return (
        <div>
            <Alert severity="error"> Error : {message} </Alert>
            <p>Please try again: <a href="/">Retry</a></p>
        </div>
    )
}